import dayjs, { Dayjs } from "utils/dayjs"

import { Guid } from "@/types"
import { AssetStoredStatus } from "./AssetDisplayStatus"
import Location, { ILocationDto, LocationSource } from "./Location"

export interface IGetAssetLocationDto {
    locatingTime?: string
    location: ILocationDto
    isCreatedManually: boolean
    source?: LocationSource | null
    clientOSInfo?: string | null
    clientBrowserInfo?: string | null
    createdBy?: Guid | null
    stateOfStorage?: AssetStoredStatus | null
}

export interface IPostAssetLocationDto {
    locatingTime?: string | null
    location: ILocationDto
    isCreatedManually: boolean
    source?: LocationSource | null
    clientOSInfo?: string | null
    clientBrowserInfo?: string | null
}

export default class AssetLocation {
    locatingTime?: Dayjs | null
    location: Location
    isCreatedManually: boolean
    source?: LocationSource | null
    clientOSInfo?: string | null
    clientBrowserInfo?: string | null
    createdBy?: Guid | null
    stateOfStorage?: AssetStoredStatus | null

    createdByEmail?: string

    constructor(dto: IGetAssetLocationDto, params: { createdByEmail?: string } = {}) {
        this.locatingTime = dto.locatingTime
            ? dayjs(dto.locatingTime)
            : null
        this.location = new Location(dto.location)
        this.isCreatedManually = dto.isCreatedManually
        this.source = dto.source
        this.clientOSInfo = dto.clientOSInfo
        this.clientBrowserInfo = dto.clientBrowserInfo
        this.createdBy = dto.createdBy
        this.createdByEmail = params.createdByEmail
        this.stateOfStorage = dto.stateOfStorage
    }

    toDto(): IPostAssetLocationDto {
        return {
            locatingTime: this.locatingTime
                ? this.locatingTime.toISOString()
                : null,
            location: this.location.toDto(),
            isCreatedManually: this.isCreatedManually,
            source: this.source,
            clientOSInfo: this.clientOSInfo,
            clientBrowserInfo: this.clientBrowserInfo,
        }
    }

}
